/**
 * 轻量请求封装：分享详情页专用，不依赖登录。
 * 约定：HTTP 200 且 body.err_code === 0 为成功。
 */
const BASE = (process.env.VUE_APP_API_BASE || '').replace(/\/$/, '')

export async function get(path, params = {}) {
  const query = new URLSearchParams()
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === '') return
    query.set(key, String(value))
  })
  const qs = query.toString()
  const url = `${BASE}${path}${qs ? `?${qs}` : ''}`

  const res = await fetch(url, {
    method: 'GET',
    headers: { Accept: 'application/json' },
  })
  if (!res.ok) {
    throw new Error(`网络错误 (${res.status})`)
  }
  const body = await res.json()
  if (body == null || typeof body !== 'object') {
    throw new Error('返回数据异常')
  }
  if (Number(body.err_code) !== 0) {
    throw new Error(body.err_msg || body.message || '请求失败')
  }
  return body.data
}
